import { Injectable } from '@angular/core';
import { StatusStackModel, StatusType } from '@shared/status-bar/status-bar.interface';
import { Observable, Subject, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatusBarService {
  statusStack$: Observable<StatusStackModel>;
  private readonly _statusStack$: Subject<StatusStackModel> = new Subject();

  constructor() {
    this.statusStack$ = this._statusStack$.asObservable().pipe(distinctUntilChanged());
  }

  setStatus(status: string, type: StatusType) {
    this._statusStack$.next({ message: status, type: type });
  }
}
